import {NgModule,  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductsComponent} from './products.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ProductComponent } from './components/product/product.component';
import { ProductDetailsComponent } from './components/product-details/product-details.component';
import { ProductFilterComponent } from './components/product-filter/product-filter.component';
import {RouterModule} from '@angular/router';
import {productRouting} from './products.routes';
import {NgxPaginationModule} from 'ngx-pagination';
import {MatDialogModule, MatSnackBarModule, MatCardModule, MatTabsModule, MatIconModule, MatInputModule, MatDatepickerModule, MatFormFieldModule, MatRadioModule} from '@angular/material';
import { ShoppingCartComponent } from './components/shopping-cart/shopping-cart.component';
import { SlicePipe } from '@angular/common';
import { CheckoutComponent } from './components/checkout/checkout.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxLoadingModule, } from 'ngx-loading';

import { ProductcategoryComponent } from './components/productcategory/productcategory.component';

import { SearchComponent } from './components/search/search.component';

import { SharedModule } from '../common/shared.module';
import { ProductmenuComponent } from './productmenu/productmenu.component';
import { FlexLayoutModule } from '@angular/flex-layout';

import { AddshippingaddressComponent } from './components/addshippingaddress/addshippingaddress.component';
import { AddbillingaddressComponent } from './components/addbillingaddress/addbillingaddress.component';
import {AgmCoreModule, GoogleMapsAPIWrapper} from '@agm/core';
import { MapComponent } from './components/map/map.component';
import { UseraddressComponent } from './components/useraddress/useraddress.component';
import { PuppycornerComponent } from './components/puppycorner/puppycorner.component';
import { KittencornerComponent } from '../products/components/kittencorner/kittencorner.component';
import { OrderplacedComponent } from './components/orderplaced/orderplaced.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { FilterModule } from '../filter/filter.module';


@NgModule({
  imports: [
    CommonModule,
    productRouting,
    NgxPaginationModule,
    FormsModule,
    NgbModule,
    NgxLoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatDialogModule,
    FilterModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCVSpuWBEclSSgdccExuKLlKUORxWSqUFU'
    }),
    MatSnackBarModule,MatDialogModule,MatCardModule,MatTabsModule,MatIconModule,
    MatInputModule,MatDatepickerModule,MatFormFieldModule, MatRadioModule
  ],
  declarations: [
    ProductsComponent,
    ProductListComponent,
    ProductComponent,
    ProductDetailsComponent,
    ShoppingCartComponent,
    ProductFilterComponent,
    CheckoutComponent,
    SearchComponent,
    AddshippingaddressComponent,
    AddbillingaddressComponent,
    MapComponent,
    UseraddressComponent,
    PuppycornerComponent,
    KittencornerComponent,
    OrderplacedComponent,
    CategoriesComponent,
    ProductcategoryComponent,
    ProductmenuComponent
  ],
  entryComponents: [MapComponent],
  providers: [ GoogleMapsAPIWrapper ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
],
})
export class ProductsModule { }
